import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import PreviewKitchenDetails from './preview-kitchen-details';
import PreviewBrands from './preview-brands';
import PreviewFeeds from './preview-feeds';
import useCokitchenContext from 'contexts/cokitchen.context';

const CokitchenPreview = () => {
  const [activeTab, setActiveTab] = useState<number>(1);
  const { setDisabled, createCokitchenForm } = useCokitchenContext();
  const tabs = [
    { text: 'Kitchen details', value: 1 },
    {
      text: 'Brands',
      value: 2
    }
  ];

  useEffect(() => {
    if (
      createCokitchenForm.brand_ids?.[0] &&
      createCokitchenForm.name &&
      createCokitchenForm.address &&
      createCokitchenForm.customer_service_phone_number?.[0]
    )
      setDisabled(false);
    else setDisabled(true);
  }, [createCokitchenForm]);

  return (
    <div>
      <PageHeaderText title='Preview' description='Lorem ipsum dolor amet til lisu nei til met' />

      <div className='my-6 flex'>
        {tabs.map((tab) => (
          <div
            key={tab.value}
            className={`py-2 px-5 border-white  border-[0.4px] rounded cursor-pointer
            ${activeTab === tab.value ? 'bg-white border-[#EAEBEB] shadow rounded-full' : ''}
            `}
            onClick={() => setActiveTab(tab.value)}>
            <p className='text-sm font-medium'>{tab.text}</p>
          </div>
        ))}
      </div>
      <div>
        {activeTab === 1 && <PreviewKitchenDetails />}
        {activeTab === 2 && <PreviewBrands />}
        {activeTab === 3 && <PreviewFeeds />}
      </div>
    </div>
  );
};

export default CokitchenPreview;
